import { render, staticRenderFns } from "./NolaNovelUpdateConfirm.vue?vue&type=template&id=1470c595&scoped=true"
import script from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts"
export * from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelUpdateConfirm.vue?vue&type=style&index=0&id=1470c595&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470c595",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1470c595')) {
      api.createRecord('1470c595', component.options)
    } else {
      api.reload('1470c595', component.options)
    }
    module.hot.accept("./NolaNovelUpdateConfirm.vue?vue&type=template&id=1470c595&scoped=true", function () {
      api.rerender('1470c595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/nolaNovel/NolaNovelUpdateConfirm.vue"
export default component.exports